import React from 'react';
import PropTypes from 'prop-types';
import SimilarSeriesEventTypes from 'data/types/SimilarSeriesEventTypes';
import CardCarousel from 'react/views/carousel/CardCarousel';

const ItemHeight='190px';

const SimilarSeriesTitles = (props) => (
	<CardCarousel
		items={props.resultData}
		itemHeight={ItemHeight}
		marginTop={props.marginTop}
		marginBottom={props.marginBottom}
		jacketClickEvent={SimilarSeriesEventTypes.SIMILARSERIES_DETAILVIEWCOVER_CLICKED}
		titleClickEvent={SimilarSeriesEventTypes.SIMILARSERIES_DETAILVIEWNAME_CLICKED}
		otsFindItEvent={SimilarSeriesEventTypes.SIMILARSERIES_FINDIT_CLICKED}
		otsClickEvent={SimilarSeriesEventTypes.SIMILARSERIES_AVAILABILITY_CLICKED}
		otsEnabled={props.otsEnabled}
		small
	/>
);

SimilarSeriesTitles.propTypes = {
	resultData: PropTypes.array,
	marginTop: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
	marginBottom: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
	otsEnabled: PropTypes.bool
}

SimilarSeriesTitles.defaultProps = {
	otsEnabled: false
}

export default SimilarSeriesTitles;
export {ItemHeight};



// WEBPACK FOOTER //
// ./src/react/views/similarSeries/SimilarSeriesTitles.jsx